import { KeyboardEvent } from 'react'

export function handleKeyCodes(e: KeyboardEvent<HTMLDivElement>) {
  if (['E', 'e', '.', '-', '+'].includes(e.key)) {
    e.preventDefault()
  }
}
